<template>
    <div>
        <!--FULLNAME-->
        <div class="field mt-2 mb-3" v-if="have('fullname')">
            <span class="text-color-secondary">
                {{ lang('name_send') }}
                <span v-if="v$.fullname && v$.fullname.required"> ({{ lang('req') }})</span>:
            </span>
            <div class='w-full mt-2'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"  
                        :class="{ 'p-invalid': v$.fullname && v$.fullname.$model && v$.fullname.$invalid }">
                        <i class="pi pi-user" />
                    </InputGroupAddon>
                    <InputText input-id="fullname" type="text" v-model="state.fullname" :placeholder="lang('fullname')"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.fullname && v$.fullname.$model && v$.fullname.$invalid }"
                        aria-describedby="name-help" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.fullname && v$.fullname.$model && v$.fullname.$invalid }">
                        <i v-if="state.fullname" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('fullname')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('fullname')" />
                    </InputGroupAddon>
                </InputGroup>
                <small v-if="v$.fullname && v$.fullname.$errors" class="p-error"
                    v-for="(error, index) of v$.fullname.$errors" :key="index">{{ error.$message }}<br></small>
            </div>
        </div>

        <!--CARD_NUMBER-->
        <div class="field mt-2 mb-3" v-if="have('card_number')">
            <span class="text-color-secondary">
                {{ lang('card_number') }}
                <span v-if="v$.card_number && v$.card_number.required"> ({{ lang('req') }})</span>:
            </span>
            <div class="w-full mt-2">
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right">
                        <i class="pi pi-credit-card" />
                    </InputGroupAddon>
                    <InputMask input-id="card_number" v-model="state.card_number" mask="9999-9999-9999-9999" 
                        :class="{ 'p-invalid': v$.card_number && v$.card_number.$model && v$.card_number.$invalid }" size="large"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0"
                        aria-describedby="card-help" :placeholder="lang('card_number')" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left">
                        <i v-if="state.card_number" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('card_number')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('card_number')" />
                    </InputGroupAddon>
                </InputGroup>
                <small v-if="v$.card_number && v$.card_number.$errors" class="p-error"
                    v-for="(error, index) of v$.card_number.$errors" :key="index">{{ error.$message }}<br></small>
            </div>
        </div>

        <!--ACCOUNT_NUMBER-->
        <div class="field mt-2 mb-3" v-if="have('account_number')">
            <span class="text-color-secondary">
                {{ lang('account_send') }}
                <span v-if="v$.account_number && v$.account_number.required"> ({{ lang('req') }})</span>:
            </span>
            <div class="w-full mt-2">
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.account_number && v$.account_number.$model && v$.account_number.$invalid }">
                        <i class="pi pi-id-card " />
                    </InputGroupAddon>
                    <InputText input-id="account_number" type="text" v-model="state.account_number" aria-describedby="account-help"
                        :placeholder="lang('account_number')" size="large" v-numeric
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0"
                        :class="{'p-invalid': v$.account_number && v$.account_number.$model && v$.account_number.$invalid }" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.account_number && v$.account_number.$model && v$.account_number.$invalid }">
                        <i v-if="state.account_number" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('account_number')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('account_number')" />
                    </InputGroupAddon>
                </InputGroup>
                <!--TODO: подсветить вложенный div у инпута при ошибке-->
                <small v-if="v$.account_number && v$.account_number.$errors" class="p-error"
                    v-for="(error, index) of v$.account_number.$errors" :key="index">{{ error.$message }}<br></small>
            </div>
        </div>

        <!--PHONE_NUMBER-->
        <div class="field mt-2 mb-3" v-if="have('phone_number')">
            <span class="text-color-secondary">
                {{ lang('phone_number') }}
                <span v-if="v$.phone_number && v$.phone_number.required"> ({{ lang('req')}})</span>:
            </span>
            <div class="w-full mt-2 mb-3">
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.phone_number && v$.phone_number.$model && v$.phone_number.$invalid }">
                        <i class="pi pi-phone" />
                    </InputGroupAddon>
                    <InputText input-id="phone_number" type="text" v-model="state.phone_number" v-numeric
                        :placeholder="get_placeholder(currency)" aria-labelledby="phone" size="large"
                        aria-describedby="phone-help"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0"
                        :class="{ 'p-invalid': v$.phone_number && v$.phone_number.$model && v$.phone_number.$invalid }" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.phone_number && v$.phone_number.$model && v$.phone_number.$invalid }">
                        <i v-if="state.phone_number" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('phone_number')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('phone_number')" />
                    </InputGroupAddon>
                </InputGroup>
                <small v-if="v$.phone_number && v$.phone_number.$errors" class="p-error"
                    v-for="(error, index) of v$.phone_number.$errors" :key="index">{{ error.$message }}<br></small>
            </div>
        </div>

        <!-- SWIFT_CODE -->
        <div class="field mt-2 mb-3" v-if="have('swift_code')">
            <span class="text-color-secondary">
                {{ lang('swift_code') }}
                <span v-if="v$.swift_code && v$.swift_code.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.swift_code && v$.swift_code.$model && v$.swift_code.$invalid }">
                        <i class="pi" />
                    </InputGroupAddon>
                    <InputText input-id="swift_code" v-model="state.swift_code" aria-describedby="swift_code-help"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.swift_code && v$.swift_code.$model && v$.swift_code.$invalid }" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.swift_code && v$.swift_code.$model && v$.swift_code.$invalid }">
                        <i v-if="state.swift_code" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('swift_code')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('swift_code')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!-- IBAN_NUMBER -->
        <div class="field mt-2 mb-3" v-if="have('iban_number')">
            <span class="text-color-secondary">
                {{ lang('iban_number') }}
                <span v-if="v$.iban_number && v$.iban_number.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.iban_number && v$.iban_number.$model && v$.iban_number.$invalid }">
                        <i class="pi" />
                    </InputGroupAddon>
                    <InputText input-id="iban_number" type="text" v-model="state.iban_number" aria-describedby="iban_number-help"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.iban_number && v$.iban_number.$model && v$.iban_number.$invalid }" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.iban_number && v$.iban_number.$model && v$.iban_number.$invalid }">
                        <i v-if="state.iban_number" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('iban_number')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('iban_number')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!-- UPI_ID / IPA -->
        <div class="field mt-2 mb-3" v-if="have('upi_id')">
            <span class="text-color-secondary">
                <span v-if="currency && currency.code=='egp'">IPA (InstaPay Address)</span>
                <span v-else>{{ lang('upi_id') }}</span>
                <span v-if="v$.upi_id && v$.upi_id.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.upi_id && v$.upi_id.$invalid && state.upi_id }">
                        <i class="pi pi-wallet" />
                    </InputGroupAddon>
                    <InputText input-id="upi_id" v-model="state.upi_id" aria-describedby="upi_id-help"
                        :placeholder="currency && currency.code=='egp' ? 'InstaPay Address' : lang('upi_id_placeholder')"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.upi_id && v$.upi_id.$invalid && state.upi_id }" :min="0"/>
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.upi_id && v$.upi_id.$invalid && state.upi_id }">
                        <i v-if="state.upi_id" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('upi_id')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('upi_id')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!-- BANK_NAME -->
        <div class="field mt-2 mb-3" v-if="have('bank_name')">
            <span class="text-color-secondary">
                {{ lang('bank_name') }}
                <span v-if="v$.bank_name && v$.bank_name.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.bank_name && v$.bank_name.$model && v$.bank_name.$invalid }">
                        <i class="pi" />
                    </InputGroupAddon>
                    <InputText input-id="bank_name" type="text" v-model="state.bank_name" aria-describedby="name-help"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.bank_name && v$.bank_name.$model && v$.bank_name.$invalid }"/>
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.bank_name && v$.bank_name.$model && v$.bank_name.$invalid }">
                        <i v-if="state.bank_name" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('bank_name')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('bank_name')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!-- CITY -->
        <div class="field mt-2 mb-3" v-if="have('city')">
            <span class="text-color-secondary">
                {{ lang('city') }}
                <span v-if="v$.city && v$.city.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.city && v$.city.$model && v$.city.$invalid }">
                        <i class="pi" />
                    </InputGroupAddon>
                    <InputText input-id="city" type="text" v-model="state.city" aria-describedby="name-help"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.city && v$.city.$model && v$.city.$invalid }"/>
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.city && v$.city.$model && v$.city.$invalid }">
                        <i v-if="state.city" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('city')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('city')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!-- COUNTRY -->
        <div class="field mt-2 mb-3" v-if="have('country')">
            <span class="text-color-secondary">
                {{ lang('country') }}
                <span v-if="v$.country && v$.country.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.country && v$.country.$model && v$.country.$invalid }">
                        <i class="pi" />
                    </InputGroupAddon>
                    <InputText input-id="country" type="text" v-model="state.country" aria-describedby="name-help"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.country && v$.country.$model && v$.country.$invalid }"/>
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.country && v$.country.$model && v$.country.$invalid }">
                        <i v-if="state.country" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('country')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('country')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!-- ADDRESS -->
        <div class="field mt-2 mb-3" v-if="have('address')">
            <span class="text-color-secondary">
                {{ lang('address') }}
                <span v-if="v$.address && v$.address.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.address && v$.address.$model && v$.address.$invalid }">
                        <i class="pi" />
                    </InputGroupAddon>
                    <InputText input-id="address" type="text" v-model="state.address" aria-describedby="name-help"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.address && v$.address.$model && v$.address.$invalid }"/>
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.address && v$.address.$model && v$.address.$invalid }">
                        <i v-if="state.address" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('address')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('address')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!--TELEGRAM-->
        <div class="field mt-2 mb-3" v-if="have('telegram')">
            <span class="text-color-secondary">
                {{ lang('telegram') }}<span v-if="v$.telegram && v$.telegram.required"> ({{ lang('req') }})</span>:
            </span>
            <div class="w-full mt-2 mb-3">
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.telegram && v$.telegram.$model && v$.telegram.$invalid }">
                        <i class="pi pi-telegram" />
                    </InputGroupAddon>
                    <InputText input-id="telegram" type="text" v-model="state.telegram" aria-describedby="name-help" :placeholder="lang('telegram_placeholder')"
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0" size="large"
                        :class="{ 'p-invalid': v$.telegram && v$.telegram.$model && v$.telegram.$invalid }" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.telegram && v$.telegram.$model && v$.telegram.$invalid }">
                        <i v-if="state.telegram" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('telegram')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('telegram')" />
                    </InputGroupAddon>
                </InputGroup>
                <small v-if="v$.telegram && v$.telegram.$errors" class="p-error"
                    v-for="(error, index) of v$.telegram.$errors" :key="index">{{ error.$message }}<br></small>
            </div>
        </div>

        <!--WALLET NETWORK-->
        <div v-if="have('wallet_network')">
            <span class="text-color-secondary">{{ lang('network_list') }}:</span>
            <div @click="networks_popup_show()"
                class="input_banks flex flex-row cursor-pointer relative w-full mt-2 mb-3 py-3 px-2 mb-3 surface-border border-2 border-round-2xl justify-content-left align-items-center">
                <span class="flex text-700 text-md font-medium mx-2">
                    <span v-if="state.wallet_network">{{ getWalletNetworkTitle(state.wallet_network) }}</span>
                    <span v-else>{{lang('network_list')}}</span>
                </span>
                <i class="pi pi-chevron-down text-600 absolute right-0 mr-3"></i>
            </div>

            <Dialog v-model:visible="networks_popup" modal :header="lang('network_list')"
                class="w-full ml-2 mr-2 border-round-2xl overflow-hidden border-none" style="max-width: 500px;">
                <div v-for="item of networks_list">
                    <div class="flex flex-row cursor-pointer relative px-2 mb-3 surface-border border-2 border-round-2xl justify-content-left align-items-center input_banks"
                        @click="choose_network(item)">
                        <span class="flex text-700 text-md font-medium mx-2">
                            {{ getWalletNetworkTitle(item) }}
                        </span>
                        <div class="absolute right-0 mr-0 surface-0 p-2 border-circle">
                            <div class="surface-border border-1 border-circle">
                                <div class="border-circle" style="width:18px;height:18px;margin:3px"
                                    :class="{ 'bg-green-400': state.wallet_network == item, 'surface-0': state.wallet_network != item }">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>

        <!--WALLET ADDRESS -->
        <div class="field mt-2 mb-3" v-if="have('wallet_address')">
            <span class="text-color-secondary">
                {{ lang('wallet_address_send') }}
                <span v-if="v$.wallet_address && v$.wallet_address.required"> ({{lang('req') }})</span>:
            </span>
            <div class='w-full mt-2 mb-3'>
                <InputGroup>
                    <InputGroupAddon class="border-2 border-right-none border-round-2xl border-noround-right"
                        :class="{ 'p-invalid': v$.wallet_address && v$.wallet_address.$model && v$.wallet_address.$invalid }">
                        <i class="pi pi-wallet" />
                    </InputGroupAddon>
                    <InputText input-id="wallet_address" type="text" v-model="state.wallet_address" placeholder="3J98t1Wp..." v-wallet
                        class="w-full border-2 surface-border overflow-hidden border-right-none border-left-none px-0 text-sm font-medium" size="large"
                        :class="{ 'p-invalid': v$.wallet_address && v$.wallet_address.$model && v$.wallet_address.$invalid }" aria-describedby="name-help" />
                    <InputGroupAddon class="border-2 border-left-none border-round-2xl border-noround-left"
                        :class="{ 'p-invalid': v$.wallet_address && v$.wallet_address.$model && v$.wallet_address.$invalid }">
                        <i v-if="state.wallet_address" class="pi pi-times p-1 surface-0 border-circle cursor-pointer" @click="clearField('wallet_address')" />
                        <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="pastField('wallet_address')" />
                    </InputGroupAddon>
                </InputGroup>
            </div>
        </div>

        <!-- FILE -->
        <div class="field mt-2 mb-3" v-if="have('file')">
            <span class="text-color-secondary">
                {{ lang('file') }}:
            </span>
            <div class="w-full mt-2">
                <UploadFiles
                    :multiple="false"
                    :maxFiles="1"
                    :upload-url="`/api/admin/recipient/upload_qr/${recipientId}`"
                    @onUpload="onUploadFile"
                    @onReset="clearField('file')"
                    @onLoading="setFileLoading"
                />
                <small class="text-600">{{ lang('file_formats') }}</small>
                <div v-if="state.file" class="flex align-items-center gap-2 mt-2">
                    <span class="text-sm text-700">{{ state.file }}</span>
                    <Button icon="pi pi-times" text size="small" severity="danger" @click="clearField('file')" />
                    <Button icon="pi pi-copy" @click="copy(state.file)" size="small" class="border-round-md border-round-lg border-0" severity="secondary" outlined/>
                    <Button icon="pi pi-external-link" @click="GoToFile(state.file)" size="small" class="border-round-md border-round-lg border-0" severity="info" outlined/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper'
import UploadFiles from '@/components/widgets/UploadFiles.vue'
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import { reactive, ref } from 'vue'

export default {
    name: 'RecipientFields',
    props: ['fields', 'requiredFields', 'currency', 'allowedNetworks', 'initialFields', 'recipientId'],
    components: {
        UploadFiles
    },
    directives: {
        numeric: {
            beforeMount(el) {
                const sanitize = (val) => String(val ?? '').replace(/\D/g, '').slice(0, 30)
                const onInput = () => {
                    const clean = sanitize(el.value)
                    if (clean !== el.value) {
                        el.value = clean
                        try { el.setSelectionRange(clean.length, clean.length) } catch {}
                        el.dispatchEvent(new Event('input', { bubbles: true }))
                    }
                }
                const onKeyDown = (e) => {
                    const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab']
                    if (e.ctrlKey || e.metaKey) return
                    if (allowed.includes(e.key)) return
                    if (/^[0-9]$/.test(e.key)) {
                        const v = el.value || ''
                        const selectionLen = (el.selectionEnd - el.selectionStart)
                        const digitsLen = String(v).replace(/\D/g, '').length
                        if (digitsLen - selectionLen >= 30) e.preventDefault()
                        return
                    }
                    e.preventDefault()
                }
                const onPaste = (e) => {
                    e.preventDefault()
                    const text = (e.clipboardData || window.clipboardData)?.getData('text') || ''
                    const start = el.selectionStart || 0
                    const end = el.selectionEnd || 0
                    const before = el.value.slice(0, start)
                    const after = el.value.slice(end)
                    const next = sanitize(before + text + after)
                    el.value = next
                    try { el.setSelectionRange(next.length, next.length) } catch {}
                    el.dispatchEvent(new Event('input', { bubbles: true }))
                }
                el.__numericHandlers = { onInput, onKeyDown, onPaste }
                el.addEventListener('input', onInput)
                el.addEventListener('keydown', onKeyDown)
                el.addEventListener('paste', onPaste)
                // начальная нормализация
                const init = sanitize(el.value)
                if (init !== el.value) {
                    el.value = init
                    el.dispatchEvent(new Event('input', { bubbles: true }))
                }
            },
            unmounted(el) {
                const h = el.__numericHandlers
                if (h) {
                    el.removeEventListener('input', h.onInput)
                    el.removeEventListener('keydown', h.onKeyDown)
                    el.removeEventListener('paste', h.onPaste)
                    delete el.__numericHandlers
                }
            }
        }
        ,
        wallet: {
            beforeMount(el){
                const sanitize = (val) => String(val || '').replace(/[^0-9a-zA-Z_-]/g, '')
                const onInput = () => {
                    const clean = sanitize(el.value)
                    if (clean !== el.value) {
                        el.value = clean
                        try { el.setSelectionRange(clean.length, clean.length) } catch {}
                        el.dispatchEvent(new Event('input', { bubbles: true }))
                    }
                }
                const onKeyDown = (e) => {
                    const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab']
                    if (e.ctrlKey || e.metaKey) return
                    if (allowed.includes(e.key)) return
                    if (/^[0-9a-zA-Z_-]$/.test(e.key)) return
                    e.preventDefault()
                }
                const onPaste = (e) => {
                    e.preventDefault()
                    const text = (e.clipboardData || window.clipboardData)?.getData('text') || ''
                    const start = el.selectionStart || 0
                    const end = el.selectionEnd || 0
                    const before = el.value.slice(0, start)
                    const after = el.value.slice(end)
                    const next = sanitize(before + text + after)
                    el.value = next
                    try { el.setSelectionRange(next.length, next.length) } catch {}
                    el.dispatchEvent(new Event('input', { bubbles: true }))
                }
                el.__walletHandlers = { onInput, onKeyDown, onPaste }
                el.addEventListener('input', onInput)
                el.addEventListener('keydown', onKeyDown)
                el.addEventListener('paste', onPaste)
                // начальная нормализация
                const init = sanitize(el.value)
                if (init !== el.value) {
                    el.value = init
                    el.dispatchEvent(new Event('input', { bubbles: true }))
                }
            },
            unmounted(el){
                const h = el.__walletHandlers
                if (h) {
                    el.removeEventListener('input', h.onInput)
                    el.removeEventListener('keydown', h.onKeyDown)
                    el.removeEventListener('paste', h.onPaste)
                    delete el.__walletHandlers
                }
            }
        }
    },
    data() {
        return {
            networks_popup: false,
            mask_number: '99999999999',
            fileLoading: false,
            // TODO: передать с сервера
            networks_list: (this.allowedNetworks) ? this.allowedNetworks : ['bep20', 'erc20', 'trc20', 'ton'] // на сервере /lib/db/schema/recipientsFields.js 
        }
    },
    // задаем переменные для валидации
    setup(props, { emit }) {
        const react = reactive({
            recalculating_: false,
        })
        const state = reactive({
            fullname: null,
            phone_number: null,
            card_number: null,
            account_number: null,
            wallet_address: null,
            wallet_network: null,
            telegram: null,
            swift_code: null,
            iban_number: null,
            upi_id: null,
            bank_name: null,
            address: null,
            city: null,
            country: null,
            file: null
        })
        const createValidateRules = () => ({
            fullname: {},
            phone_number: {},
            card_number: {},
            account_number: {},
            wallet_address: {},
            wallet_network: {},
            telegram: {},
            swift_code: {},
            iban_number: {},
            upi_id: {},
            bank_name: {},
            address: {},
            city: {},
            country: {},
            file: {}
        })
        let validateRules = createValidateRules()

        // кастомный валидатор для проверки наличия @
        const hasAt = (value) => {
            if (typeof value !== 'string') return false;
            return value.includes('@');
        };

        // кастомный валидатор: только цифры
        const digitsOnly = (value) => {
            if (value === null || value === undefined) return true;
            return /^[0-9]*$/.test(String(value));
        };

        // кастомный валидатор: допустимы только символы адресов (латиница, цифры, _, -)
        const walletChars = (value) => {
            if (value === null || value === undefined || value === '') return true;
            return /^[0-9a-zA-Z_-]+$/.test(String(value));
        };

        // задаем параметры валидации для полей
        const set_validate = (arrFields, arrFieldsRequired) => {
            validateRules = createValidateRules()

            if (!arrFields || !Array.isArray(arrFieldsRequired) || !arrFieldsRequired.length) {
                return validateRules
            }

            arrFieldsRequired.forEach((key) => {
                if (!Object.prototype.hasOwnProperty.call(validateRules, key)) return

                const props = {
                    required
                }

                if (key == 'fullname') {
                    props.minLength = minLength(3)
                    props.maxLength = maxLength(30)
                }

                if (key == 'phone_number') {
                    props.minLength = minLength(7)
                    props.maxLength = maxLength(30)
                    props.digitsOnly = { $validator: digitsOnly, $message: 'Только цифры' }
                }

                if (key == 'card_number') {
                    props.minLength = minLength(16)
                    props.maxLength = maxLength(19)
                }

                if (key == 'account_number') {
                    props.minLength = minLength(8)
                    props.maxLength = maxLength(30)
                    props.digitsOnly = { $validator: digitsOnly, $message: 'Только цифры' }
                }

                if (key == 'wallet_address') {
                    props.minLength = minLength(34)
                    props.maxLength = maxLength(48)
                    props.walletChars = { $validator: walletChars, $message: 'Допустимы латинские буквы, цифры, _ и -' }
                }

                if (key == 'telegram') {
                    props.minLength = minLength(5)
                    props.maxLength = maxLength(30)
                }

                if (key == 'swift_code') {
                    props.minLength = minLength(8)
                    props.maxLength = maxLength(11)
                }

                if (key == 'iban_number') {
                    props.minLength = minLength(8)
                    props.maxLength = maxLength(30)
                }

                if (key == 'upi_id') {
                    props.minLength = minLength(5)
                    props.maxLength = maxLength(50)
                    props.hasAt = { $validator: hasAt, $message: 'Должен содержать символ @' }
                }

                if (key == 'bank_name') {
                    props.minLength = minLength(3)
                    props.maxLength = maxLength(40)
                }

                if (key == 'address') {
                    props.minLength = minLength(5)
                    props.maxLength = maxLength(100)
                }

                if (key == 'city') {
                    props.minLength = minLength(3)
                    props.maxLength = maxLength(40)
                }

                if (key == 'country') {
                    props.minLength = minLength(3)
                    props.maxLength = maxLength(40)
                }

                validateRules[key] = props
            })

            return validateRules
        };

        // сразу задаем валидацию для первых выбранных полей
        set_validate(props.fields, props.requiredFields);
        const v$ = useVuelidate(validateRules, state);
    
        return { v$, state, validateRules, react, set_validate }
    },
    watch: {
        // при смене полей снаружи - меняем требования к проверке полей и эмитим результат и заполненные поля обратно
        fields: {
            handler: function (val) {
                const newRules = this.set_validate(val, this.requiredFields)
                this.v$ = useVuelidate(newRules, this.state)
                this.$emit('check_valid', this.check_custom_valid)
                this.$emit('return_fields', this.createFields())
            },
            deep: true
        },
        // также при вводе значений 
        v$: {
            handler: function (val) {
                this.$emit('check_valid', this.check_custom_valid)
                this.$emit('return_fields', this.createFields())
            },
            deep: true
        },
        // при изменении исходных реквизитов заполняем state значениями
        initialFields: {
            handler: function (val) {
                if (!val || !this.state) return
                for (const key in this.state) {
                    if (Object.prototype.hasOwnProperty.call(val, key) && val[key] !== undefined && val[key] !== null) {
                        this.state[key] = val[key]
                    }
                }
                this.$emit('check_valid', this.check_custom_valid)
                this.$emit('return_fields', this.createFields())
            },
            deep: true,
            immediate: true
        },
    },
    computed: {
        // проверяет все поля на валидность 
        check_custom_valid() {
            if (!this.v$) return false
            if (!this.requiredFields) return false

            if (this.requiredFields.includes('fullname')) {
                if (!this.state.fullname) return false
                if (this.v$.fullname && this.v$.fullname.$invalid) return false
            }

            if (this.requiredFields.includes('phone_number')) {
                if (!this.state.phone_number) return false
                if (this.v$.phone_number && this.v$.phone_number.$invalid) return false
            }

            if (this.requiredFields.includes('card_number')) {
                if (!this.state.card_number) return false
                if (this.v$.card_number && this.v$.card_number.$invalid) return false
                if (!this.check_card_valid) return false
            }

            if (this.requiredFields.includes('account_number')) {
                if (!this.state.account_number) return false
                if (this.v$.account_number && this.v$.account_number.$invalid) return false
            }

            if (this.requiredFields.includes('telegram')) {
                if (!this.state.telegram) return false
                if (this.v$.telegram && this.v$.telegram.$invalid) return false
            }

            if (this.requiredFields.includes('wallet_address')) {
                if (!this.state.wallet_address) return false
                if (this.v$.wallet_address && this.v$.wallet_address.$invalid) return false
            }

            if (this.requiredFields.includes('wallet_network')) {
                if (!this.state.wallet_network) return false
            }

            if (this.requiredFields.includes('swift_code')) {
                if (!this.state.swift_code) return false
                if (this.v$.swift_code && this.v$.swift_code.$invalid) return false
            }

            if (this.requiredFields.includes('iban_number')) {
                if (!this.state.iban_number) return false
                if (this.v$.iban_number && this.v$.iban_number.$invalid) return false
            }

            if (this.requiredFields.includes('upi_id')) {
                if (!this.state.upi_id) return false
                if (this.v$.upi_id && this.v$.upi_id.$invalid) return false
            }

            if (this.requiredFields.includes('bank_name')) {
                if (!this.state.bank_name) return false
                if (this.v$.bank_name && this.v$.bank_name.$invalid) return false
            }

            if (this.requiredFields.includes('address')) {
                if (!this.state.address) return false
                if (this.v$.address && this.v$.address.$invalid) return false
            }

            if (this.requiredFields.includes('city')) {
                if (!this.state.city) return false
                if (this.v$.city && this.v$.city.$invalid) return false
            }

            if (this.requiredFields.includes('country')) {
                if (!this.state.country) return false
                if (this.v$.country && this.v$.country.$invalid) return false
            }

            return true
        },
    },
    methods: {
        // numericInput больше не используется — логику заменяет директива v-numeric
        // выбор маски плейсхолдера
        get_placeholder(cur) {
            if (!cur || !cur.code) return this.mask_number
            let country = this.helper.get_country_by_currency(cur.code)
            if (!country) return this.mask_number
            let prefix = (country.code) ? country.code : ''
            let masks = (country.mask) ? country.mask : [this.mask_number]
            if (typeof (masks) == 'object' && masks.length > 1) {
                let result = []
                for (let i = 0; i < masks.length; i++) {
                    result.push(this.helper.format_mask(masks[i]))
                }
                // находим самую длинну маску
                let max = 0
                let max_index = 0
                for (let i = 0; i < result.length; i++) {
                    if (result[i].length > max) {
                        max = result[i].length
                        max_index = i
                    }
                }
                return prefix + result[max_index]
            } else {
                return prefix + this.helper.format_mask(masks)
            }

        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        GoToFile(file_id) {
            // const routeData = this.$router.resolve({path: '/admin/files/', query: { id: file_id }});
            window.open(`/admin/files/?id=${file_id}`, '_blank')
        },
        // создаем объект с заполненными полями для эмита
        createFields() {
            if (!this.state) return
            if (!this.fields) return
            // возращаем только те поля, которые есть в массиве fields
            return {
                fullname: (this.fields.includes('fullname')) ? this.state.fullname : null,
                phone_number: (this.fields.includes('phone_number')) ? this.state.phone_number : null,
                card_number: (this.fields.includes('card_number')) ? this.cleanCardOrPhone(this.state.card_number) : null,
                account_number: (this.fields.includes('account_number')) ? this.state.account_number : null,
                wallet_address: (this.fields.includes('wallet_address')) ? this.state.wallet_address : null,
                wallet_network: (this.fields.includes('wallet_network')) ? this.state.wallet_network : null,
                telegram: (this.fields.includes('telegram')) ? this.state.telegram : null,
                swift_code: (this.fields.includes('swift_code')) ? this.state.swift_code : null,
                iban_number: (this.fields.includes('iban_number')) ? this.state.iban_number : null,
                upi_id: (this.fields.includes('upi_id')) ? this.state.upi_id : null,
                bank_name: (this.fields.includes('bank_name')) ? this.state.bank_name : null,
                address: (this.fields.includes('address')) ? this.state.address : null,
                city: (this.fields.includes('city')) ? this.state.city : null,
                country: (this.fields.includes('country')) ? this.state.country : null,
                file: (this.fields.includes('file') && this.state.file) ? this.state.file : undefined
            }
        },
        // проверяет номер карты без символов
        check_card_valid() {
            return this.helper.checkCardValid(this.state.card_number)
        },
        networks_popup_show(){
            this.networks_popup = true
        },
        choose_network(code){
            this.state.wallet_network = code
            this.networks_popup = false
        },
        have(code) {
            if(!this.fields) return false
            if(!code) return false
            return this.fields.includes(code)
        },
        lang(value) {
            return this.$t(`views.personal.recipientFields.${value}`)
        },
        cleanCardOrPhone(val){
            const clear_num = this.helper.cleanCardOrPhone(val)
            if(typeof(clear_num)=='string') return parseInt(clear_num)
            else return clear_num
        },
        getWalletNetworkTitle(network){
            if(!network) return '-'
            return this.helper.getWalletNetworkTitle(network)
        },
        getShortId(val) {
            if (!val) return '-'
            return this.helper.get_short_id(String(val))
        },
        setFileLoading(val) {
            this.fileLoading = !!val
        },
        onUploadFile(files) {
            if (!files || !files.length) return
            const first = files[0]
            const id = first?._id || first?.id || null
            if (!id) return
            this.state.file = id
            this.$emit('check_valid', this.check_custom_valid)
            this.$emit('return_fields', this.createFields())
        },
        async getClipboardData() {
            try {
                const text = await navigator.clipboard.readText();
                return text;
            } catch (err) {
                console.error('Failed to read clipboard contents:', err);
                return null;
            }
        },
        clearField(title){
            if (this.fields.includes(title)) {
                this.state[title] = null;
                this.$emit('check_valid', this.check_custom_valid)
                this.$emit('return_fields', this.createFields())
            } else return
        },
        async pastField(title){
            if(!title) return
            if (!this.fields.includes(title)) return
            const text = await this.getClipboardData()
            if(['phone_number','account_number','iban_number'].includes(title)){
                const clean = String(text || '').replace(/\D/g, '').slice(0, 30)
                this.state[title] = clean
            } else if (title==='wallet_address') {
                const clean = String(text || '').replace(/[^0-9a-zA-Z_-]/g, '')
                this.state[title] = clean
            } else {
                this.state[title] = text
            }
        }
    },
    beforeCreate() {
        this.helper = new Helper()
    },
    mounted() {},
}
</script>